// Calendar cloud settings base URL
export const CALENDAR_CLOUD_SETTINGS_BASE_URL = '/ows/beta/OutlookCloudSettings/settings/';

// Calendar cloud settings
export enum CalendarCloudSettingType {
    ShouldEventsEndEarly = 'Should_Event_End_Early',
    ShortenEventScope = 'shorten_event_scope',
    EndShortEventsBy = 'End_Short_meetings_by',
    EndLongEventsBy = 'End_long_meetings_by',
    EnableOnlineMeetingsByDefault = 'onlinemeetings_enabledbydefault',
}

// Calendar cloud settings request body types
export enum CalendarCloudSettingValueType {
    Bool = 'Bool',
    Int = 'Int',
    String = 'String',
}

export enum CalendarCloudSettingScopeType {
    Global = 'global',
    Account = 'account',
}

export enum CalendarCloudSettingItemClassType {
    RoamingSetting = 'roamingsetting',
}
